<script lang="ts">
	import { MessagesSquare, Moon, PanelLeft, Sun } from 'lucide-svelte';
	import { mode, toggleMode } from 'mode-watcher';

	import { goto } from '$app/navigation';

	import { createNewDefaultChat } from '$lib/chats';

	import { useSidebar } from '../ui/sidebar';
	import { commandBar } from './command-bar-state.svelte';
	import { registerNavigationCommands } from './navigation-commands';

	registerNavigationCommands();

	mode.subscribe((mode) => {
		const otherMode = mode === 'light' ? 'dark' : 'light';

		commandBar.register('appearance', 'theme', {
			icon: mode === 'light' ? Moon : Sun,
			title: `Enable ${otherMode} mode`,
			keywords: ['toggle theme', 'color theme', 'color scheme', 'dark mode', 'light mode'],
			async onSelect() {
				toggleMode();
			}
		});
	});

	const sidebar = useSidebar();
	commandBar.register('appearance', 'sidebar', {
		icon: PanelLeft,
		title: 'Toggle sidebar',
		keywords: ['open', 'close', 'menu'],
		shortcut: ['⌘', 'B'],
		registerShortcut: false, // handled by sidebar component
		async onSelect() {
			sidebar.toggle();
		}
	});

	commandBar.register('quick', 'new-default-chat', {
		icon: MessagesSquare,
		title: 'Create new chat',
		shortcut: ['⌘', '⇧', 'N'],
		registerShortcut: true,
		async onSelect() {
			const chat = await createNewDefaultChat();
			await goto(`/collections/chats/${chat.id}#bottom`);
		}
	});
</script>
